import { render } from "./SpPreview.vue?vue&type=template&id=6ef6fb0a&scoped=true"
import script from "./SpPreview.vue?vue&type=script&lang=js"
export * from "./SpPreview.vue?vue&type=script&lang=js"

import "./SpPreview.vue?vue&type=style&index=0&id=6ef6fb0a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef6fb0a"]])

export default __exports__